export default __webpack_public_path__ + "static/media/promos-icon-active.438fc6da.webp";